exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "img[data-v-3f9ed14c]{width:100%}hr[data-v-3f9ed14c]{border-top:6px double #080}\n", ""]);

